
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CreateReportSuccess',
  props: {
    reportId: {
      type: String,
      required: true
    },
    password: {
      type: String,
      default: ''
    },
    editMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    formattedUrl(): string {
      return `${window.location.origin}/report/${this.reportId}`
    },
    reportDetails(): string {
      return `View report -\nLink - ${this.formattedUrl}${
        this.password ? '\nPassword - ' + this.password : ''
      }`
    }
  }
})
